import { Injectable, OnDestroy } from '@angular/core';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { Subject, merge } from 'rxjs';
import { debounceTime, takeUntil, tap } from 'rxjs/operators';
import { UiContextActions } from '@nibtravel/shared/data-access/ui-context';
import { PlansAction } from '@nibtravel/shared/data-access/plans';
import { UnderwriterAction } from '@nibtravel/shared/data-access/underwriter';
import { QuoteActions } from './quote.actions';

@Injectable({ providedIn: 'root' })
export class QuoteEffects implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private store: Store, private actions: Actions) {}

  public init(): void {
    const pageChanged$ = this.actions.pipe(
      ofActionSuccessful(QuoteActions.SetQuoteCurrentRoute),
      debounceTime(1),
      tap(() => {
        this.store.dispatch(new UiContextActions.PageChanged());
      })
    );

    const setQuoteParams$ = this.actions.pipe(
      ofActionSuccessful(QuoteActions.SetQuoteParams),
      debounceTime(1),
      tap(() => {
        this.store.dispatch([
          new QuoteActions.UpdatePolicyholder(),
          new QuoteActions.GetQuote(),
        ]);
      })
    );

    const findQuote$ = this.actions.pipe(
      ofActionSuccessful(QuoteActions.FindQuote),
      debounceTime(1),
      tap((action: QuoteActions.FindQuote) => {
        if (action.planId) {
          this.store.dispatch([
            new QuoteActions.SetPlanForQuote(action.planId),
            new UnderwriterAction.SetCurrentContractId(action.planId),
            new PlansAction.LoadOptionsSummary(action.planId, action.brand),
          ]);
        }
        this.store.dispatch(new QuoteActions.LoadQuotePlans());
      })
    );

    merge(pageChanged$, setQuoteParams$, findQuote$)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
